module.exports = __webpack_public_path__ + "img/home-01.fefe7a34.svg";